export const NEW_INSTRUMENT_TYPES = {
  BANK: {
    system: 'BANK',
    userFriendly: 'bank',
  },
  DEBIT_CARD: {
    system: 'DEBIT_CARD',
    userFriendly: 'debitcard',
  },
  CARD: {
    system: 'CARD',
    userFriendly: 'card',
  },
}

export const FUNDING_SOURCES = {
  BALANCE: 'BALANCE',
  BANK: 'BANK',
  CARD: 'CARD',
  DEBIT: 'DEBIT',
  CREDIT: 'CREDIT',
  DEBIT_CARD: 'DEBIT_CARD',
  CREDIT_CARD: 'CREDIT_CARD',
  PAYPAL_CREDIT: 'PAYPAL_CREDIT',
}

export const AMEX = 'American Express'

export const ISSUER_NAMES = [
  'AMEX',
  'CB_NATIONALE',
  'CETELEM',
  'CHINA_UNION_PAY',
  'COFIDIS',
  'COFINOGA',
  'DELTA',
  'DISCOVER',
  'ELECTRON',
  'ELO',
  'HIPER',
  'HIPERCARD',
  'JCB',
  'MAESTRO',
  'MASTER_CARD',
  'RUPAY',
  'SOLO',
  'STAR',
  'SWITCH',
  'VISA',
]

export const BANK_TYPES = [
  'BUSINESS_CHECKING',
  'BUSINESS_SAVINGS',
  'CHECKING',
  'SAVINGS',
  'BANKTYPEFALLBACK',
]

export const BANK_TYPE_VALUES = {
  BUSINESS_CHECKING: 'BUSINESS_CHECKING',
  BUSINESS_SAVINGS: 'BUSINESS_SAVINGS',
  CHECKING: 'CHECKING',
  SAVINGS: 'SAVINGS',
  BANKTYPEFALLBACK: 'BANKTYPEFALLBACK',
}